type BannedEntryApplicationState = {
  readonly is_applied: boolean;
};

export function toggleBannedEntryApplied<T extends BannedEntryApplicationState>(
  entry: T
): T {
  return { ...entry, is_applied: !entry.is_applied };
}
